// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".qr-floating-btn[data-v-3ce9710a]{position:absolute;top:24px;left:24px;z-index:20;background-color:rgba(196,139,7,.9)!important;color:#fff;-webkit-box-shadow:0 4px 10px rgba(0,0,0,.3);box-shadow:0 4px 10px rgba(0,0,0,.3);padding:15px!important}", ""]);
// Exports
module.exports = exports;
